export const getRoleAndOrganization = (state) => {
  const { role, organization } = state;
  return { role, organization };
};

export const getRole = (state) => {
  const { role } = state;
  return { role };
};
